const isDevelopment = false;
export default isDevelopment;
